/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreatePhaseRequest
 */
export interface CreatePhaseRequest {
  /**
   *
   * @type {string}
   * @memberof CreatePhaseRequest
   */
  name?: string | null;
}

export function CreatePhaseRequestFromJSON(json: any): CreatePhaseRequest {
  return CreatePhaseRequestFromJSONTyped(json, false);
}

export function CreatePhaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePhaseRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: !exists(json, "name") ? undefined : json["name"],
  };
}

export function CreatePhaseRequestToJSON(value?: CreatePhaseRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
  };
}
